// Aktív poszt — session-scoped reference object that lets the user spin
// a Facebook post into a LinkedIn / Reels / Carousel variation without
// re-typing the topic + CTA. Lives in sessionStorage so it's wiped on
// logout / page-close (per spec: "nem perzisztens").
//
// Shape:
//   {
//     forras_alkartya: "facebook" | "linkedin" | "reels" | "carousel",
//     tema: string,
//     cta_tipus: "beszelgetes" | "ingyenes" | "jelentkezes",
//     valasztott_insight: { insight_cim, horog, uj_nezopont } | null,
//     teljes_poszt_szoveg: string,
//   }

const KEY = "mex_active_poszt";

export function getActivePost() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    return v && typeof v === "object" ? v : null;
  } catch {
    return null;
  }
}

export function setActivePost(post) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(post));
  } catch {}
}

export function clearActivePost() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}
